export const environmentData = {
  run: 'development',
  development: {
    clientId: 'ce03ce39-9810-4d47-89d7-b3a4d28b309d',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid ce03ce39-9810-4d47-89d7-b3a4d28b309d/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=9c7b92eb-2909-4a1d-9241-c91d3617a3ab;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    apiBaseURL: 'https://gateway-test.hapi.hmgroup.com/integrationmonitoring/v1/',
    apiBaseURLBam: 'https://gateway-test.hapi.hmgroup.com/integrationmonitoring/v1/',
    dashboardAdminEmail: 'enterprise.dashboard@hm.com',
    OcpApimSubscriptionKey: 'c71035aff4ca4b2a974f2908e96926bc',
  },
  staging: {
    clientId: 'ce03ce39-9810-4d47-89d7-b3a4d28b309d',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid ce03ce39-9810-4d47-89d7-b3a4d28b309d/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=73ba61b6-af6e-47cd-a9f1-e20711b90ca5;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    apiBaseURL: 'https://dev-api-execdb-ps.azurewebsites.net/api',
    apiBaseURLBam: 'https://integrationmonitoringprod.azurewebsites.net',
    dashboardAdminEmail: 'enterprise.dashboard@hm.com',
  },
  production: {
    clientId: 'ce03ce39-9810-4d47-89d7-b3a4d28b309d',
    authority: 'https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8',
    tenantId: '30f52344-4663-4c2e-bab3-61bf24ebbed8',
    'api-scope': 'openid ce03ce39-9810-4d47-89d7-b3a4d28b309d/User.Impersonation',
    appInsightConnectionString:
      'InstrumentationKey=73ba61b6-af6e-47cd-a9f1-e20711b90ca5;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    apiBaseURL: 'https://gateway.hapi.hmgroup.com/integrationmonitoring/v1/',
    apiBaseURLBam: 'https://gateway.hapi.hmgroup.com/integrationmonitoring/v1/',
    dashboardAdminEmail: 'enterprise.dashboard@hm.com',
    OcpApimSubscriptionKey: '3ba62e5463d14bbba43134ef44f5b56a',
  },
}
